export default {
  MERCH_VENDOR: 'VENDOR',
  BEAUTY_VENDOR: 'BEAUTY_VENDOR',
};
